<template>
    <div>
        <v-dialog v-model="sellDialog" max-width="500px" persistent>
            <v-form>
                <v-card>
                    <v-card-title>
                        <span>Sell Containers</span>
                    </v-card-title>

                    <v-card-text>
                        <autocomplete-multiple :key="autocompleteKey" v-model="selectedContainers" :filter="filter" label="Containers" item-text="label" item-value="id" url="/api/Containers/Autocomplete" />
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="tertiary" text @click="cancel()">Cancel</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="quaternary" text @click="newSale()">Add to New Sale</v-btn>
                        <v-btn color="quaternary" text @click="existingSale()">Add to Existing Sale</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="saleDialog" max-width="500px" persistent>
            <sale-form :filter="saleFilter" @cancel="cancel()" @open="saleDialog = true" @input="onSaleInput" />
        </v-dialog>
        <v-dialog v-model="saleSelectionDialog" max-width="500px" persistent>
            <sale-selection-form @cancel="cancel()" @open="saleSelectionDialog = true" @input="onSaleSelectionInput" />
        </v-dialog>
    </div>
</template>

<script>
    import securityService from "../services/securityService";
    import axios from 'axios'
    export default {
        props: [
            'filter'
        ],

        components: {
            autocompleteMultiple: () => import('../components/AutocompleteMultiple'),
            saleForm: () => import('../forms/SaleForm'),
            saleSelectionForm: () => import('../forms/SaleSelectionForm')
        },

        data() {
            return {
                sellDialog: true,
                saleSelectionDialog: false,
                saleDialog: false,
                selectedContainers: [],
                autocompleteKey: 0
            }
        },

        methods: {
            newSale() {
                this.sellDialog = false;
                this.saleDialog = true;
            },
            existingSale() {
                this.sellDialog = false;
                this.saleSelectionDialog = true;
            },
            async onSaleInput(sale) {
                sale.containerIds = Object.keys(this.selectedContainers).map(k => { return this.selectedContainers[k] });
                await axios.post('/api/SaleContainers/SellContainers', sale);
                this.$emit('input');
                this.saleDialog = false;
            },
            async onSaleSelectionInput(saleId) {
                var sale = { saleId };
                sale.containerIds = Object.keys(this.selectedContainers).map(k => { return this.selectedContainers[k] });
                await axios.post('/api/SaleContainers/ExistingSaleContainers', sale);
                this.$emit('input');
                this.saleSelectionDialog = false;
            },
            cancel() {
                this.$emit('cancel');
                this.sellDialog = false;
                this.saleDialog = false;
                this.saleSelectionDialog = false;
            }
        },
        computed: {
            saleFilter() {
                var memberId = securityService.getMemberId();
                if (memberId) {
                    return {
                        sellerName: '',
                        ...this.filter
                    };
                }
                return this.filter;
            }
        }
    };
</script>
